import { defineMessages, useIntl } from 'react-intl';

class Tr {
  private intl: any;
  constructor() {
    this.intl = useIntl();
  }
  titlebarDisplay() {
    return this.intl.formatMessage({
      id: 'titlebar.display',
      defaultMessage: 'Display',
    });
  }
  titlebarMarginLine() {
    return this.intl.formatMessage({
      id: 'titlebar.marginLine',
      defaultMessage: 'Margin Line',
    });
  }
  titlebarOcclusionMapping() {
    return this.intl.formatMessage({
      id: 'titlebar.occlusionMapping',
      defaultMessage: 'Occlusion Proximity',
    });
  }
  titlebarOrientationAdjustment() {
    return this.intl.formatMessage({
      id: 'titlebar.orientationAdjustment',
      defaultMessage: 'Orientation Adjustment',
    });
  }
  titlebarGallery() {
    return this.intl.formatMessage({
      id: 'titlebar.gallery',
      defaultMessage: 'Gallery',
    });
  }
  titlebarExport() {
    return this.intl.formatMessage({
      id: 'titlebar.export',
      defaultMessage: 'Export',
    });
  }
  titlebarImageInfo() {
    return this.intl.formatMessage({
      id: 'titlebar.imginfo',
      defaultMessage: 'Image Information',
    });
  }
  titlebarAbout() {
    return this.intl.formatMessage({
      id: 'titlebar.about',
      defaultMessage: 'About',
    });
  }
  titlebarHelp() {
    return this.intl.formatMessage({
      id: 'titlebar.help',
      defaultMessage: 'Help',
    });
  }
  displayDentalArch() {
    return this.intl.formatMessage({
      id: 'display.dentalArch',
      defaultMessage: 'Dental Arch',
    });
  }
  displayBuccalBite() {
    return this.intl.formatMessage({
      id: 'display.buccalBite',
      defaultMessage: 'Buccal Bite',
    });
  }
  displayShow() {
    return this.intl.formatMessage({
      id: 'display.show',
      defaultMessage: 'Show',
    });
  }
  displayHide() {
    return this.intl.formatMessage({
      id: 'display.hide',
      defaultMessage: 'Hide',
    });
  }
  galleryPrevious() {
    return this.intl.formatMessage({
      id: 'gallery.previous',
      defaultMessage: 'Previous',
    });
  }
  galleryNext() {
    return this.intl.formatMessage({
      id: 'gallery.next',
      defaultMessage: 'Next',
    });
  }
  galleryDownload() {
    return this.intl.formatMessage({
      id: 'gallery.download',
      defaultMessage: 'Download',
    });
  }
  galleryDelete() {
    return this.intl.formatMessage({
      id: 'gallery.delete',
      defaultMessage: 'Delete',
    });
  }
  galleryFullScreen() {
    return this.intl.formatMessage({
      id: 'gallery.fullScreen',
      defaultMessage: 'Full Screen',
    });
  }
  occlusionCaculating() {
    return this.intl.formatMessage({
      id: 'occlionsion.caculating',
      defaultMessage: 'Calculate Occlusion Pressure',
    });
  }
  occlusionProximity() {
    return this.intl.formatMessage({
      id: 'occlionsionMeter.title',
      defaultMessage: 'Occlusion Proximity',
    });
  }
  occlusionCollision() {
    return this.intl.formatMessage({
      id: 'occlionsionMeter.collision',
      defaultMessage: 'Collision',
    });
  }
  occlusionContact() {
    return this.intl.formatMessage({
      id: 'occlionsionMeter.contact',
      defaultMessage: 'Contact',
    });
  }
  occlusionStrong() {
    return this.intl.formatMessage({
      id: 'occlionsionMeter.strong',
      defaultMessage: 'Strong',
    });
  }
  occlusionAverage() {
    return this.intl.formatMessage({
      id: 'occlionsionMeter.average',
      defaultMessage: 'Average',
    });
  }
  occlusionWeak() {
    return this.intl.formatMessage({
      id: 'occlionsionMeter.weak',
      defaultMessage: 'Weak',
    });
  }
  occlusionVeryWeak() {
    return this.intl.formatMessage({
      id: 'occlionsionMeter.veryWeak',
      defaultMessage: 'Very Weak',
    });
  }
  changeLanguage() {
    return this.intl.formatMessage({
      id: 'titlebar.changeLanguage',
      defaultMessage: 'Change Language',
    });
  }
  orientFront() {
    return this.intl.formatMessage({
      id: 'canvasToolbar.viewFront',
      defaultMessage: 'View Front',
    });
  }
  orientBack() {
    return this.intl.formatMessage({
      id: 'canvasToolbar.viewBack',
      defaultMessage: 'View Back',
    });
  }
  orientTop() {
    return this.intl.formatMessage({
      id: 'canvasToolbar.viewTop',
      defaultMessage: 'View Top',
    });
  }
  orientBottom() {
    return this.intl.formatMessage({
      id: 'canvasToolbar.viewBottom',
      defaultMessage: 'View Bottom',
    });
  }
  orientRight() {
    return this.intl.formatMessage({
      id: 'canvasToolbar.viewRight',
      defaultMessage: 'View Right',
    });
  }
  orientLeft() {
    return this.intl.formatMessage({
      id: 'canvasToolbar.viewLeft',
      defaultMessage: 'View Left',
    });
  }
  zoomFit() {
    return this.intl.formatMessage({
      id: 'canvasToolbar.zoomFit',
      defaultMessage: 'Zoom Fit',
    });
  }
  takeSnapshot() {
    return this.intl.formatMessage({
      id: 'canvasToolbar.takeSnapshot',
      defaultMessage: 'Take Snapshot',
    });
  }
  switchTrueColor() {
    return this.intl.formatMessage({
      id: 'canvasToolbar.switchTrueColor',
      defaultMessage: 'Switch True Color',
    });
  }
  switchLight() {
    return this.intl.formatMessage({
      id: 'canvasToolbar.switchLight',
      defaultMessage: 'Switch Light',
    });
  }
  reset() {
    return this.intl.formatMessage({
      id: 'general.reset',
      defaultMessage: 'Reset',
    });
  }
  generalOK() {
    return this.intl.formatMessage({
      id: 'general.OK',
      defaultMessage: 'OK',
    });
  }
  generalCancel() {
    return this.intl.formatMessage({
      id: 'general.cancel',
      defaultMessage: 'Cancel',
    });
  }
  exportFormat() {
    return this.intl.formatMessage({
      id: 'export.exportFormat',
      defaultMessage: 'Export format',
    });
  }
  exportOrientationOptions() {
    return this.intl.formatMessage({
      id: 'export.orientationOptions',
      defaultMessage: 'Orientation Options',
    });
  }
  exportEnableOrientationLabel() {
    return this.intl.formatMessage({
      id: 'export.enableOrientationLabel',
      defaultMessage: 'Export with Orientation presets',
    });
  }
  plyWithDesc() {
    return this.intl.formatMessage({
      id: 'export.plyWithDesc',
      defaultMessage: 'PLY (Polygon Model File Format)',
    });
  }
  stlWithDesc() {
    return this.intl.formatMessage({
      id: 'export.stlWithDesc',
      defaultMessage: 'STL (Stereolithography File Format)',
    });
  }
  showOcclusionPlane() {
    return this.intl.formatMessage({
      id: 'orientationAdjustment.showOcclusionPlane',
      defaultMessage: 'Show Occlusion Plane',
    });
  }
  rotationStep() {
    return this.intl.formatMessage({
      id: 'orientationAdjustment.rotationStep',
      defaultMessage: 'Rotation Step',
    });
  }
  movementStep() {
    return this.intl.formatMessage({
      id: 'orientationAdjustment.movementStep',
      defaultMessage: 'Movement Step',
    });
  }
  angle() {
    return this.intl.formatMessage({
      id: 'orientationAdjustment.angle',
      defaultMessage: 'Angle',
    });
  }
  distance() {
    return this.intl.formatMessage({
      id: 'orientationAdjustment.distance',
      defaultMessage: 'Distance(mm)',
    });
  }
  increase() {
    return this.intl.formatMessage({
      id: 'orientationAdjustment.increase',
      defaultMessage: 'Increase',
    });
  }
  decrease() {
    return this.intl.formatMessage({
      id: 'orientationAdjustment.decrease',
      defaultMessage: 'Decrease',
    });
  }
  orientationAdjustmentResetAll() {
    return this.intl.formatMessage({
      id: 'orientationAdjustment.resetAll',
      defaultMessage: 'Reset All Adjustments',
    });
  }
  imageInfoPatientName() {
    return this.intl.formatMessage({
      id: 'imageInfo.patientName',
      defaultMessage: 'Patient Name',
    });
  }
  imageInfoPatientID() {
    return this.intl.formatMessage({
      id: 'imageInfo.patientID',
      defaultMessage: 'Patient ID',
    });
  }
  imageInfoModelName() {
    return this.intl.formatMessage({
      id: 'imageInfo.modelName',
      defaultMessage: `Manufacturer's model name`,
    });
  }
  imageInfoAcquisitionTime() {
    return this.intl.formatMessage({
      id: 'imageInfo.acquisitionTime',
      defaultMessage: 'Acquisition time',
    });
  }
  imageInfoSerialNumber() {
    return this.intl.formatMessage({
      id: 'imageInfo.serialNumber',
      defaultMessage: 'Device serial number',
    });
  }
  imageInfoAcquisitionType() {
    return this.intl.formatMessage({
      id: 'imageInfo.acquisitionType',
      defaultMessage: 'Acquisition type',
    });
  }
  imageInfoSoftwareVersion() {
    return this.intl.formatMessage({
      id: 'imageInfo.softwareVersion',
      defaultMessage: 'Acquisition software version',
    });
  }
  aboutDlgProductVersion() {
    return this.intl.formatMessage({
      id: 'aboutDlg.productVersion',
      defaultMessage: 'Product version',
    });
  }
  aboutDlgRightNotice(year: number) {
    const messages = defineMessages({
      notice: {
        id: 'aboutDlg.rightNotice',
        defaultMessage: '© {year} Carestream Dental LLC. All Rights Reserved',
      },
    });
    return this.intl.formatMessage(messages.notice, { year });
  }
  aboutDlgFollowUS() {
    return this.intl.formatMessage({
      id: 'aboutDlg.followUs',
      defaultMessage: 'Follow us on social media:',
    });
  }
  aboutDlgCSDonSocialMedia(media: string) {
    const messages = defineMessages({
      linking: {
        id: 'aboutDlg.CSDonSocialMedia',
        defaultMessage: 'Carestream Dental on {media}',
      },
    });
    return this.intl.formatMessage(messages.linking, { media });
  }
  dragAreaDragTip() {
    return this.intl.formatMessage({
      id: 'dragArea.dragTip',
      defaultMessage: 'Click this button or drag files here to import the data',
    });
  }
  dragAreaReleaseTip() {
    return this.intl.formatMessage({
      id: 'dragArea.releaseTip',
      defaultMessage: 'Release to start importing the files',
    });
  }
  dragAreaSupportTip(format: string) {
    const messages = defineMessages({
      supportTip: {
        id: 'dragArea.supportTip',
        defaultMessage: 'Only supports {format} files',
      },
    });
    return this.intl.formatMessage(messages.supportTip, { format });
  }
  unsupportedFileAlert() {
    return this.intl.formatMessage({
      id: 'general.unsupportedAlert',
      defaultMessage: 'File format not supported',
    });
  }
  busyDlgImportData() {
    return this.intl.formatMessage({
      id: 'busyDlg.importData',
      defaultMessage: 'Import Data',
    });
  }
  patient() {
    return this.intl.formatMessage({
      id: 'generalNoun.patient',
      defaultMessage: 'Patient',
    });
  }
  unknown() {
    return this.intl.formatMessage({
      id: 'generalNoun.unknown',
      defaultMessage: 'Unknown',
    });
  }
  busyDlgProcessing() {
    return this.intl.formatMessage({
      id: 'busyDlg.processing',
      defaultMessage: 'Processing, please wait...',
    });
  }
  meshName(name: string) {
    name = name.replace(/ /g, '_');
    const messages = defineMessages({
      transMeshName: {
        id: 'enums.meshName',
        defaultMessage: `{meshName, select,
          Maxillary {Maxillary}
          Maxillary_Anatomy {Maxillary Anatomy}
          Maxillary_Edentulous {Maxillary Edentulous}
          Maxillary_Pre_Scan {Maxillary Pre Scan}
          Maxillary_Implant {Maxillary Implant}
          Mandibular {Mandibular}
          Mandibular_Anatomy {Mandibular Anatomy}
          Mandibular_Edentulous {Mandibular Edentulous}
          Mandibular_Pre_Scan {Mandibular Pre Scan}
          Mandibular_Implant {Mandibular Implant}
          BiteAverage {BiteAverage}
          Extra_Object {Extra Object}
          other {{meshName}}
        }`,
      },
    });
    const translatedName = this.intl.formatMessage(messages.transMeshName, { meshName: name });
    return translatedName.replace(/_/g, ' ');
  }
}

export default Tr;
